import http from '../../http';

export function fetchAccountBySlug (companySlug) {
  return (dispatch) => dispatch({
    type: 'FETCH_ACCOUNT',
    payload: http().get(`company/${companySlug}/details`),
  });
}
